import { useState, useEffect } from "react";
import { sweetAl, toast } from "../../../../core/helpers/message-helper";
import ContentWrapper from "../../../../core/ui/components/Layout/ContentWrapper";
import CalendarioEventos from "../../../../core/ui/components/Calendar/Calendario";
import {
    crearFestivo,
    eliminarFestivo,
    listarFestivos,
} from "../../services/festivos-service";

const Festivos = () => {
    const [eventos, setEventos] = useState([]);
    const [festivos, setFestivos] = useState([]);

    useEffect(async () => {
        const resp = await listarFestivos();
        if (!resp.status) return toast.error(resp.message);
        const eventos = resp.data.map((ev) => {
            return {
                id: ev.id,
                start: ev.fecha,
                title: ev.nombre,
                className: ev.color,
            };
        });

        setEventos([...eventos]);
        setFestivos([...eventos]);
    }, []);

    const onEventoAñadido = (nuevoEvento) => {
        nuevoEvento.id = eventos.length + 1;
        setEventos((prev) => [...prev, nuevoEvento]);
    };

    const onEventoClick = async (e) => {
        const valor = await sweetAl.confirm(
            "¿Está seguro que desea eliminar este día festivo?"
        );
        if (valor == false) return;

        const evento = e.event.extendedProps;
        const resp = await eliminarFestivo(evento.start);
        if (!resp.status) return toast.error(resp.message);

        toast.success(resp.message);
        setFestivos((prev) => {
            const index = prev.findIndex((item) => item.id == evento.id);
            prev.splice(index, 1);
            return [...prev];
        });
    };

    const onFechaPulsada = async (fecha, evento) => {
        const { title, className } = evento;
        const resp = await crearFestivo(title, fecha, className);
        if (!resp.status) return toast.error(resp.message);

        toast.success(resp.message);
        setFestivos((prev) => [
            ...prev,
            { title, id: resp.data.id, className, start: fecha },
        ]);
    };

    return (
        <ContentWrapper>
            <div className="content-heading">
                <div>
                    ADMINISTRAR / Festivos
                </div>
            </div>
            <CalendarioEventos
                eventos={eventos}
                dependeDeEventos={true}
                onEventoClick={onEventoClick}
                onFechaPulsada={onFechaPulsada}
                eventosSeleccionados={festivos}
                onEventoAñadido={onEventoAñadido}
            />
        </ContentWrapper>
    );
};

export default Festivos;
